ko.bindingHandlers.singleClick = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext)
	{
		//This handler helps when combining single and dblclicks. 
		//in all other cases you can use click (or action when it returns a promise)
		let handler = valueAccessor(),
			delay = 200,
			clickTimeout = null;

		const click = (e) =>
		{
			if (clickTimeout) {
				clearTimeout(clickTimeout);
				clickTimeout = null;
			} else {
				clickTimeout = setTimeout(function ()
				{
					clickTimeout = false;
					handler.apply(viewModel, [viewModel, e]);
				}, delay);
			}
			e.preventDefault();
			e.stopPropagation();
		}

		element.addEventListener('click',  click);
		//remove bindinghandler when done
		ko.utils.domNodeDisposal.addDisposeCallback(element, () =>
		{
			element.removeEventListener('click', click);
		})
	}

};